import {ApiService} from "../index";
import {APIConfig} from "../../../constants";

const getAccountExecutiveList = (payload: any) => {
    // @ts-ignore
    return ApiService[APIConfig.USER_LIST.METHOD](APIConfig.USER_LIST.URL, payload);
}

const registerPatient = (payload: any) => {
    // @ts-ignore
    return ApiService[APIConfig.Register.METHOD](APIConfig.Register.URL, payload);
}

const savePatientIntakeForm = (panelCode: string, payload: any) => {
    // @ts-ignore
    return ApiService[APIConfig.SAVE_TEST_PANEL_INTAKE_FORM.METHOD](APIConfig.SAVE_TEST_PANEL_INTAKE_FORM.URL(panelCode), payload);
}

const getTestResults = (payload: any) => {
    // @ts-ignore
    return ApiService[APIConfig.GET_TEST_RESULT.METHOD](APIConfig.GET_TEST_RESULT.URL, payload);
}

const downloadCsv = (payload: any) => {
    // @ts-ignore
    return ApiService[APIConfig.FACILITY_CSV_DOWNLOAD.METHOD](APIConfig.FACILITY_CSV_DOWNLOAD.URL, payload);
}

const getOcrToken = (payload: any) => {
    // @ts-ignore
    return ApiService[APIConfig.GET_TOKEN.METHOD](APIConfig.GET_TOKEN.URL, payload);
}

const userToggleStatus = (id: any, payload: any) => {
    // @ts-ignore
    return ApiService[APIConfig.USER_TOGGLE_STATUS.METHOD](APIConfig.USER_TOGGLE_STATUS.URL(id), payload);
}

const getUserDetails = (userId: any, payload: any) => {
    // @ts-ignore
    return ApiService[APIConfig.USER_DETAILS.METHOD](APIConfig.USER_DETAILS.URL(userId), payload);
}
const addUser = (payload: any) => {
    // @ts-ignore
    return ApiService[APIConfig.ADD_USER.METHOD](APIConfig.ADD_USER.URL, payload);
}
const getRolePermissions = (payload: any) => {
    // @ts-ignore
    return ApiService[APIConfig.GET_ROLE_PERMISSIONS.METHOD](APIConfig.GET_ROLE_PERMISSIONS.URL, payload);
}

const adduserRoles = (userId: any, roleId: any, payload: any) => {
    // @ts-ignore
    return ApiService[APIConfig.ADD_USER_ROLES.METHOD](APIConfig.ADD_USER_ROLES.URL(userId, roleId), payload);
}

const editUser = (userId: any, payload: any) => {
    // @ts-ignore
    return ApiService[APIConfig.EDIT_USER.METHOD](APIConfig.EDIT_USER.URL(userId), payload);
}

const getUserRoles = (userId: any, payload: any) => {
    // @ts-ignore
    return ApiService[APIConfig.GET_USER_ROLES.METHOD](APIConfig.GET_USER_ROLES.URL(userId), payload);
}

const deleteUser = (userId: any, payload: any) => {
    // @ts-ignore
    return ApiService[APIConfig.DELETE_USER.METHOD](APIConfig.DELETE_USER.URL(userId), payload);
}
const updateUserPassword = (payload: any) => {
    return ApiService[APIConfig.UPDATE_USER_PASSWORD.METHOD](APIConfig.UPDATE_USER_PASSWORD.URL, payload)
}
const UserService = {
    getAccountExecutiveList,
    registerPatient,
    savePatientIntakeForm,
    getTestResults,
    downloadCsv,
    getOcrToken,
    userToggleStatus,
    getUserDetails,
    addUser,
    getRolePermissions,
    adduserRoles,
    editUser,
    getUserRoles,
    deleteUser,
    updateUserPassword
}

export default UserService;
